var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    staticClass: "box",
    attrs: {
      title: _vm.$t("数据导入"),
      visible: _vm.importVisible,
      width: 1000,
      height: 1000
    },
    on: {
      cancel: _vm.handleCancel
    }
  }, [_c("template", {
    slot: "footer"
  }, [_vm.importStatus === "BEFOREUPLOAD" ? _c("a-button", {
    key: "back",
    on: {
      click: _vm.back
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("上一步")) + " ")]) : _vm._e(), _vm.importStatus === "BEFOREUPLOAD" ? _c("a-button", {
    key: "submit",
    attrs: {
      type: "primary",
      disabled: _vm.disableNextButton
    },
    on: {
      click: _vm.next
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("下一步")) + " ")]) : _vm._e(), _vm.importStatus === "UPLOADCOMPLATE" || _vm.importStatus === "UPLOADCOMPLATE" ? _c("a-button", {
    key: "submit",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("关闭")) + " ")]) : _vm._e()], 1), _vm.importStatus === "UPLOAD" ? _c("a-spin", {
    staticClass: "upload-loading",
    staticStyle: {
      width: "100%",
      height: "600px"
    },
    attrs: {
      tip: _vm.$t("正在上传，请稍候")
    }
  }) : _vm.importStatus === "UPLOADCOMPLATE" || _vm.importStatus === "UPLOADERROR" ? _c("div", {
    staticClass: "import-complate"
  }, [_c("a-icon", {
    class: _vm.importStatus === "UPLOADCOMPLATE" ? "complate-icon" : "error-icon",
    attrs: {
      type: "check-circle"
    }
  }), _c("div", {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.importStatus === "UPLOADCOMPLATE" ? _vm.$t("数据导入完成") : _vm.$t("导入失败")))]), _vm.importStatus === "UPLOADCOMPLATE" ? _c("div", [_vm._v(_vm._s(_vm.$t("您已成功导入") + _vm.dataInfo.length + _vm.$t("条数据")))]) : _vm._e()], 1) : _c("div", [_c("a-steps", {
    staticClass: "step",
    attrs: {
      current: _vm.current
    }
  }, _vm._l(_vm.steps, function (item) {
    return _c("a-step", {
      key: _vm.$t(item.title),
      attrs: {
        title: _vm.$t(item.title)
      }
    });
  }), 1), _vm.current === 0 ? _c("div", [_c("div", {
    staticClass: "box-item"
  }, [_c("span", {
    staticClass: "down-class"
  }, [_c("svg-icon", {
    attrs: {
      icon: "download",
      color: "#ccc",
      size: 100
    }
  })], 1), _c("div", {
    staticClass: "down-text"
  }, [_c("div", {
    staticClass: "text-one"
  }, [_vm._v(_vm._s(_vm.$t("填写导入数据信息")))]), _c("div", {
    staticClass: "text-second"
  }, [_vm._v(" " + _vm._s(_vm.$t("请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除")) + " ")]), _c("a", {
    staticClass: "link-class",
    on: {
      click: _vm.download
    }
  }, [_vm._v(_vm._s(_vm.$t("下载模板")))])])]), _c("div", {
    staticClass: "box-item"
  }, [_c("span", {
    staticClass: "down-class"
  }, [_c("svg-icon", {
    attrs: {
      icon: "upload",
      color: "#ccc",
      size: 100
    }
  })], 1), _c("div", {
    staticClass: "down-text"
  }, [_c("div", {
    staticClass: "text-one"
  }, [_vm._v(_vm._s(_vm.$t("上传填好的信息表")))]), _c("div", {
    staticClass: "text-second"
  }, [_vm._v(" " + _vm._s(_vm.$t("文件后缀名必须为xls 或xlsx(即Excel格式),文件大小不得大于1M,最多支持导入1000条数据")) + " ")]), _c("a-upload", {
    attrs: {
      fileList: _vm.fileList,
      beforeUpload: _vm.beforeUpload,
      remove: _vm.remove
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.fileList.length == 0 ? _c("a", {
    staticClass: "link-class"
  }, [_vm._v(_vm._s(_vm.$t("上传文件")))]) : _vm._e()])], 1)])]) : _vm._e(), _vm.current === 1 ? _c("div", [_c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.dataInfo,
      pagination: _vm.pagination,
      rowClassName: _vm.getClassName
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (text, record, index) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.editRecord(record, index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("修改")))]), _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.deleteRecord(index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }, {
      key: "expandedRowRender",
      fn: function (record) {
        return record.errorMessage && record.errorMessage.length ? _vm._l(record.errorMessage, function (item) {
          return _c("span", {
            key: item,
            staticClass: "err-line"
          }, [_vm._v(_vm._s(_vm.$t(item)))]);
        }) : undefined;
      }
    }], null, true)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1) : _vm._e()], 1)], 2), _c("a-modal", {
    staticClass: "box",
    attrs: {
      title: _vm.$t("数据修改"),
      visible: _vm.editVisible,
      width: 1000,
      height: 1000
    },
    on: {
      cancel: _vm.editCancel,
      ok: _vm.handleOk
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.rules
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("工种"),
      prop: "occupation"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-left": "10px",
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("工种"),
      allowClear: ""
    },
    model: {
      value: _vm.form.occupation,
      callback: function ($$v) {
        _vm.$set(_vm.form, "occupation", $$v);
      },
      expression: "form.occupation"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("姓名"),
      prop: "name"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-left": "10px",
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("姓名"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("证件类型"),
      prop: "identificationType"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-left": "10px",
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("证件类型"),
      allowClear: ""
    },
    model: {
      value: _vm.form.identificationType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "identificationType", $$v);
      },
      expression: "form.identificationType"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("证件号码"),
      prop: "idNumber"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-left": "10px",
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("证件号码"),
      allowClear: ""
    },
    model: {
      value: _vm.form.idNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "idNumber", $$v);
      },
      expression: "form.idNumber"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("责任起期"),
      prop: "startAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      disabled: _vm.policyInfo.declarationMethod === "DAY",
      format: _vm.getFormatDate() + " HH:mm:ss" + _vm.dateChronaxie(),
      disabledDate: _vm.disabledDate,
      placeholder: _vm.$t("请输入") + _vm.$t("责任起期")
    },
    on: {
      change: _vm.onChangeTime
    },
    model: {
      value: _vm.form.startAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "startAt", $$v);
      },
      expression: "form.startAt"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保费"),
      prop: "premium"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-left": "10px",
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("保费"),
      allowClear: "",
      disabled: ""
    },
    model: {
      value: _vm.form["premium"],
      callback: function ($$v) {
        _vm.$set(_vm.form, "premium", $$v);
      },
      expression: "form['premium']"
    }
  }, [_c("span", {
    attrs: {
      slot: "addonAfter"
    },
    slot: "addonAfter"
  }, [_vm._v(_vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))))])])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };